var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import moment from "moment";
import { MUTUAL_FUNDS_SIP_STP_SWP_TRANSACTIONS, MUTUAL_FUNDS_SIP_STP_SWP_TRANSACTIONS_ERROR, MUTUAL_FUNDS_SIP_STP_SWP_TRANSACTIONS_HIDE_ERROR, MUTUAL_FUNDS_SIP_STP_SWP_TRANSACTIONS_TABLE_START_LOADER, MUTUAL_FUNDS_SIP_STP_SWP_TRANSACTIONS_TABLE_STOP_LOADER, MUTUAL_FUNDS_SIP_STP_SWP_CLEAR_ALL_FILTERS, MUTUAL_FUNDS_SIP_STP_SWP_UPDATE_FILTERS, MUTUAL_FUNDS_SIP_STP_SWP_CLEAR_ALL_FILTERS_AND_SEARCH, } from "../interface/IMutualFundsSIP_STP_SWP_Transactions";
export var SIP_STP_SWP_InitialData = {
    SIP_STP_SWP_TransactionsData: undefined,
    errorData: {
        error: undefined,
        isOpen: false,
    },
    mutualFundSIP_STP_SWP_TransactionsTableShimmer: false,
    appliedFilters: {
        fromDate: moment().startOf("month").format("YYYY-MM-DD"),
        toDate: moment().format("YYYY-MM-DD"),
        txnType: 1,
        status: [],
        clientCodes: [],
        searchText: "",
    },
};
var mutualFundsSIP_STP_SWP_TransactionsReducer = function (state, action) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    if (state === void 0) { state = JSON.parse(JSON.stringify(SIP_STP_SWP_InitialData)); }
    switch (action.type) {
        case MUTUAL_FUNDS_SIP_STP_SWP_TRANSACTIONS:
            return __assign(__assign({}, state), { SIP_STP_SWP_TransactionsData: {
                    data: {
                        order: (_c = (_b = (_a = action === null || action === void 0 ? void 0 : action.payload) === null || _a === void 0 ? void 0 : _a.SIP_STP_SWP_TransactionsData) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.order,
                        tranSummaryList: (_f = (_e = (_d = action === null || action === void 0 ? void 0 : action.payload) === null || _d === void 0 ? void 0 : _d.SIP_STP_SWP_TransactionsData) === null || _e === void 0 ? void 0 : _e.data) === null || _f === void 0 ? void 0 : _f.tranSummaryList,
                        clientCodeList: [],
                    },
                    status: (_h = (_g = action === null || action === void 0 ? void 0 : action.payload) === null || _g === void 0 ? void 0 : _g.SIP_STP_SWP_TransactionsData) === null || _h === void 0 ? void 0 : _h.status,
                } });
        case MUTUAL_FUNDS_SIP_STP_SWP_TRANSACTIONS_ERROR:
            return __assign(__assign({}, state), { 
                // ...SIP_STP_SWP_InitialData,
                SIP_STP_SWP_TransactionsData: undefined, mutualFundSIP_STP_SWP_TransactionsTableShimmer: false, errorData: action.payload.errorData });
        case MUTUAL_FUNDS_SIP_STP_SWP_TRANSACTIONS_HIDE_ERROR:
            return __assign(__assign({}, state), { errorData: SIP_STP_SWP_InitialData.errorData });
        case MUTUAL_FUNDS_SIP_STP_SWP_TRANSACTIONS_TABLE_START_LOADER:
            return __assign(__assign({}, state), { mutualFundSIP_STP_SWP_TransactionsTableShimmer: true });
        case MUTUAL_FUNDS_SIP_STP_SWP_TRANSACTIONS_TABLE_STOP_LOADER:
            return __assign(__assign({}, state), { mutualFundSIP_STP_SWP_TransactionsTableShimmer: false });
        case MUTUAL_FUNDS_SIP_STP_SWP_UPDATE_FILTERS:
            return __assign(__assign({}, state), { appliedFilters: action.payload.appliedFilters });
        case MUTUAL_FUNDS_SIP_STP_SWP_CLEAR_ALL_FILTERS:
            return __assign(__assign({}, state), { appliedFilters: JSON.parse(JSON.stringify(SIP_STP_SWP_InitialData.appliedFilters)), fromDate: state.appliedFilters.fromDate, toDate: state.appliedFilters.toDate });
        case MUTUAL_FUNDS_SIP_STP_SWP_CLEAR_ALL_FILTERS_AND_SEARCH:
            return __assign(__assign({}, state), { appliedFilters: JSON.parse(JSON.stringify(SIP_STP_SWP_InitialData.appliedFilters)) });
        default:
            return __assign({}, state);
    }
};
export default mutualFundsSIP_STP_SWP_TransactionsReducer;
